import React from 'react';
import { createSlug } from '../../util/urlHelpers';
import { NamedLink } from '../../components';
import AspectRatioWrapper from '../../components/AspectRatioWrapper/AspectRatioWrapper';

import css from './SellPage.module.css';

// Card for a real recently-sold listing. Links to the listing page (which shows the
// closed/sold state) and carries a "Sold" badge. Long titles truncate with an ellipsis.
const SoldListingCard = ({ sale }) => {
  const { id, title, imageUrl, daysToSell } = sale;
  const slug = createSlug(title || 'listing');
  const soldLine = daysToSell
    ? `Sold after ${daysToSell} ${daysToSell === 1 ? 'day' : 'days'}`
    : null;

  return (
    <NamedLink className={css.soldCard} name="ListingPage" params={{ id, slug }}>
      <AspectRatioWrapper width={4} height={3} className={css.soldAspect}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            className={css.soldImage}
            width={480}
            height={360}
            loading="lazy"
          />
        ) : (
          <div className={css.soldImagePlaceholder} aria-hidden="true" />
        )}
      </AspectRatioWrapper>
      <div className={css.soldInfo}>
        <div className={css.soldTitle}>{title}</div>
        {soldLine ? <div className={css.soldMeta}>{soldLine}</div> : null}
      </div>
    </NamedLink>
  );
};

export default SoldListingCard;
